/**
 * Demo Page
 * Interactive routing demonstration
 */

import { DemoSection } from '@/components/sections/demo';
import { UseCasesSection } from '@/components/sections/use-cases';
import { CtaSection } from '@/components/sections/cta';

export function DemoPage() {
  return (
    <>
      <div className="pt-24">
        <div className="max-w-4xl mx-auto px-4 py-16 text-center">
          <div className="backdrop-blur-md bg-background/60 border border-border/50 rounded-2xl p-8 md:p-12 shadow-xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Interactive Demo</h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Try our intelligent routing engine live. See how Naivana analyzes your prompts and selects the optimal model.
            </p>
          </div>
        </div>
      </div>
      <DemoSection />
      <UseCasesSection />
      <CtaSection />
    </>
  );
}
